/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class MultiTranslateHttpLoader implements TranslateLoader {
  constructor(
    private _http: HttpClient,
    private _resources: { prefix: string; suffix: string }[]
  ) {}

  public getTranslation(lang: string): Observable<any> {
    const requests = this._resources.map((resource) => {
      const path = resource.prefix + lang + resource.suffix;
      return this._http.get(path);
    });

    return forkJoin(requests).pipe(
      map((response: any[]) => {
        const result = this.mergeCustom(response[0], response[1]);

        return result;
      })
    );
  }

  deepMergeShared(base: any, override: any): any {
    const result: any = { ...base };

    for (const key in override) {
      if (override[key] && typeof override[key] === 'object' && !Array.isArray(override[key])) {
        result[key] = this.deepMergeShared(base?.[key] || {}, override[key]);
      } else {
        result[key] = override[key];
      }
    }

    return result;
  }

  mergeCustom(base: any, override: any): any {
    const result: any = { ...base };

    if (override.ADMIN) {
      result.ADMIN = override.ADMIN;
    }

    if (override.SHARED) {
      result.SHARED = this.deepMergeShared(base.SHARED || {}, override.SHARED);
    }

    return result;
  }
}

// Factory function required for AOT (Ahead-of-Time) compilation
export function httpLoaderFactory(http: HttpClient): MultiTranslateHttpLoader {
  return new MultiTranslateHttpLoader(http, [
    {
      prefix: './public/i18n/shared/', // Path for the shared library files
      suffix: '.json',
    },
    {
      prefix: './public/i18n/', // Path for the admin application files
      suffix: '.json',
    },
  ]);
}
